<template>
    <component
        :is="buttonComponent"
        class="button-subheader cursor-pointer"
        type="button"
        :class="buttonClasses"
        :disabled="buttonDisabled"
        :to="buttonRoute"
        v-bind="buttonHref ? {href: buttonHref} : {}"
        @click="buttonClick(buttonClickParams)"
    >
        <span class="flex flex-row space-x-2 items-center">
            <span v-if="buttonIcon">
                <component :is="iconComponent" :marginAuto="false"></component>
            </span>
            <span :class="buttonIcon ? 'hidden sm:inline' : ''">{{ buttonText }}</span>
        </span>
    </component>
</template>

<script>
export default {
    name: 'ButtonSubheader',
    props: {
        buttonDisabled: {
            required: false,
            type: [Boolean, Number],
            default: false,
        },
        buttonRoute: {
            required: false,
            type: [String, Object],
            default: null,
        },
        buttonHref: {
            required: false,
            type: String,
            default: null,
        },
        buttonText: {
            required: false,
            type: String,
            default: null,
        },
        buttonIcon: {
            required: false,
            type: String,
            default: null,
        },
        buttonClick: {
            required: false,
            type: Function,
            default: () => {},
        },
        buttonClickParams: {
            required: false,
            type: [String, Object, Array],
            default: null,
        },
        dark: {
            required: false,
            type: Boolean,
            default: false,
        },
    },
    computed: {
        iconComponent() {
            return 'icon-' + this.buttonIcon;
        },
        buttonComponent() {
            if (this.buttonRoute) return 'router-link';
            if (this.buttonHref) return 'a';
            return 'button';
        },
        buttonClasses() {
            const cls = {};
            cls['flex-column flex items-center'] = true;
            cls['text-base font-medium'] = true;
            cls['cursor-pointer'] = true;
            cls['bg-transparent text-black'] = !this.dark;
            cls['bg-transparent text-white'] = !!this.dark;
            cls['disabled:bg-zinc-500'] = !!this.buttonDisabled;
            return cls;
        },
    },
};
</script>
